import { configure } from 'axios-hooks';
import Axios, { AxiosError } from 'axios';

export const axiosClient = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axiosClient.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers.set('token', token);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
  (response) => {
    if (response?.data?.token) {
      localStorage.setItem('token', response.data.token);
    }
    return response;
  },
  async (error: AxiosError<any>) => {
    if (error?.response?.status === 401) {
      window.location.href = new URL(process.env.PUBLIC_URL.concat('/login'), window.location.href).href;
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

configure({ axios: axiosClient });
